import { Outlet } from 'react-router-dom'

import { MyTrainingsDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

export default function MyTrainingDetailRevamp() {
  const { trainingId } = useStrictParams<'trainingId'>()
  const session = useCurrentSession()
  const accessId = session.access.id
  const employeeId = session.employee.id
  const { data, loading, error } = useQuery(MyTrainingsDocument, {
    variables: {
      accessId,
      employeeId,
      trainingId: Number(trainingId),
      companyIds: [session.company.id],
      companyId: session.company.id,
    },
  })
  const training = data?.trainings.trainingsConnection.nodes.at(0)
  return (
    <ResponsivePage.Body showHeader={false} loading={loading} error={error}>
      <Outlet
        context={{
          training,
          classFiles: data?.trainings.trainingClassFilesConnection.nodes,
          trainingFiles: data?.trainings.trainingFilesConnection.nodes,
          certificates: data?.trainings.trainingMembershipsConnection.nodes.flatMap(
            (membership) => membership.trainingMembershipFilesConnection.nodes
          ),
        }}
      />
    </ResponsivePage.Body>
  )
}
